import { Link, Typography } from '@mui/material';

import RowWrap from '../common/IntakeRowWrap';

function NoInpatientCareWarning() {
  return (
    <RowWrap>
      <Typography style={{ marginBottom: '50px' }}>
        We are sorry, because you selected that your facility does not provide inpatient care, you
        are ineligible to apply for the Tree Campus Healthcare program. If you have any questions,
        please contact <Link href='mailto:healthcare@arborday.org'>healthcare@arborday.org</Link>.
      </Typography>
    </RowWrap>
  );
}

export default NoInpatientCareWarning;
